export const TYPES = {
  ToolSelectorController: Symbol.for('Indications/ToolSelectorController'),
  ToolStateStore: Symbol.for('Indications/ToolStateStore'),
  ToolsManagerFactory: Symbol.for('Indications/ToolsManagerFactory'),
  IIndicationsFactory: Symbol.for('Indications/IIndicationsFactory'),
  IIndicationsViewModelFactory: Symbol.for('Indications/IIndicationsViewModelFactory'),
  IndicationsService: Symbol.for('Indications/IndicationsService'),
  AnnotationTwoDController: Symbol.for('Indications/AnnotationTwoDController'),
  BoxesIndicationStore: Symbol.for('BoxesIndicationStore'),
  IndicationsCommandsFactory: Symbol.for('Indications/IndicationsCommandsFactory'),
  RemoveIndicationCommandsFactory: Symbol.for('Indications/RemoveIndicationCommandsFactory')
};
